module.exports = __webpack_public_path__ + "fonts/icomoon.19eb00f.woff";